const ADULT_CHILD = [{ value: 'adult', label: 'ผู้ใหญ่' }, { value: 'child', label: 'เด็ก' }];

export default ADULT_CHILD;
